/** External Import */
import { useState } from "react";

/** Intenal Import */
import CSS      from "./Write.module.css";
import Overlay  from "@/Component/Elements/Overlay/Overlay";
import Textarea from "@/Component/Elements/Textarea/Textarea";
import Button   from "@/Component/Elements/Button/Normal/Button";

// fetch.ts import
import fetchBE              from    "@/Common/fetch/fetchBE";

interface it_WriteProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => Promise<void> | void;
}





function Write(iProps: it_WriteProps) {

    /** 문의 내용 */
    const [postContent, setPostContent] = useState<string>("");

    /** 문의 등록 핸들러 */
    async function hdlSubmit() {

        try {

            // postContent가 없는 경우 alert로 안내하고 등록을 중단한다.
            if(!postContent.trim()){
                alert("문의 내용을 입력해주세요.");
                return;
            }

            if ( !confirm("문의 내용을 등록하시겠습니까?") ) {
                return;
            }





            // 문의 등록 API 호출
            const _fetchData = await fetchBE.post.postSave({
                board_pk : 1 ,
                contents : postContent ,
            });

            if(!_fetchData.isSuccess){
                throw new Error(_fetchData.errorMessage || "문의 등록에 실패했습니다.");
            }





            // 등록 성공
            await iProps.onSuccess?.();
            setPostContent("");

            alert("문의가 등록되었습니다.");
            iProps.onClose();

        } catch ( iError : any ) {

            let _msg = `문의 등록 중 오류가 발생했습니다. ${iError.message ? "\n\n오류 메시지: " + iError.message : ""}`;

            alert(_msg);

        }

    }


    return (
        <Overlay
            isOverlayOpen={iProps.isOpen}
            overlayCloseHandler={iProps.onClose}
        >
            <div className={CSS.PostDetailPopup}>
                <div className={CSS.PostDetailTopBar}>
                    <h3 className={CSS.PostDetailHeading}>문의 하기</h3>
                </div>

                <div className={CSS.PostDetailSection}>
                    <Textarea
                        class_name_list={[CSS.PostContent]}
                        placeholder="문의 내용을 입력해주세요."
                        value={postContent}
                        onChange={(e) => {
                            setPostContent(e.target.value)
                        }}
                    />
                </div>

                <Button
                    class_name_list={[CSS.SubmitButton]}
                    onClick={() => {void hdlSubmit()}}
                >
                    등록하기
                </Button>
            </div>
        </Overlay>
    );
}

export default Write;
